import triggerService from '../service/trigger'

const state =
{
    loading: false,
    triggers: [],
};

const actions = {

    assignDevice({ commit }, { trigger,device }) {
        return triggerService.assignDevice(trigger,device)
    },
    removeDevice({ commit }, { trigger,device }) {
        return triggerService.removeDevice(trigger,device)
    },
    getTriggers({ commit }) {
        commit('setLoading', true)
        return triggerService.getTriggers().then(triggers => {
            commit('setTriggers', triggers)
        }).finally(() =>
            commit('setLoading', false)
        )
    },

    updateStatusShadow({ commit }, shadow) {

        commit('setStatusShadow', shadow)
    },
    updateConfigShadow({ commit }, shadow) {
        commit('setConfigShadow', shadow)
    },
    // eslint-disable-next-line no-empty-pattern
    updateRequestedConfig({ }, requested) {
        return triggerService.updateConfig(requested.id, requested)
    }

};
const mutations = {

    setLoading(state, bool) {
        state.loading = bool
    },
    setTriggers(state, triggers) {
        state.triggers = triggers
        state.loading = false
    },
    setStatusShadow(state, shadow) {
        let index = state.triggers.findIndex(x => x._id == shadow.id)
        if (index != -1) {
            state.triggers[index].status = {
                ...state.triggers[index].status,
                shadow: shadow
            }
        }
    },
    setConfigShadow(state, shadow) {
        // console.log(shadow)
        let index = state.triggers.findIndex(x => x._id == shadow.id)
        if (index != -1) {
            state.triggers[index].config = {
                ...state.triggers[index].config,
                shadow: shadow
            }
        }
    },

};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
